import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-031ba9a1"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-user" }, null, -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Poslat email s obnovením hesla ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Zpět na přihlášení")

import {
	NInput,
	NButton,
	NSpace,
	NForm,
	NFormItem,
	NInputGroup,
	NInputGroupLabel,
	NResult,
	FormRules,
	FormValidationError,
} from 'naive-ui';
import { ref } from 'vue';
import { API } from '@/api';
import UnauthorizedLayout from '@/layouts/UnauthorizedLayout.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const pending = ref<boolean>(false);
const formRef = ref();
const message = ref<string | undefined>();
const formModel = ref({
	username: null,
});
const rules = ref<FormRules>({
	username: [
		{
			required: true,
			message: 'Uživatelské jméno je povinné',
			trigger: ['input', 'blur'],
		},
	],
});
const submitForm = async () => {
	message.value = undefined;

	if (formRef.value !== null && typeof formRef.value.validate === 'function') {
		await formRef.value.validate(async (validationErrors: FormValidationError) => {
			if (!validationErrors) {
				pending.value = true;
				try {
					await API.auth.forgottenPassword(formModel.value.username || '');
					pending.value = false;
					message.value =
						'Pokud jsme nalezli Váš účet, tak Vám odešleme email s dalšími instrukcemi';
				} catch (catchError) {
					pending.value = false;
					message.value =
						'Pokud jsme nalezli Váš účet, tak Vám odešleme email s dalšími instrukcemi';
				}
			}
		});
	}
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(UnauthorizedLayout, {
    width: "300px",
    title: "Zapomenuté heslo"
  }, {
    default: _withCtx(() => [
      (message.value)
        ? (_openBlock(), _createBlock(_unref(NResult), {
            key: 0,
            status: "success",
            class: "pt-m",
            description: typeof message.value === 'string' ? message.value : ''
          }, null, 8, ["description"]))
        : (_openBlock(), _createBlock(_unref(NForm), {
            key: 1,
            ref_key: "formRef",
            ref: formRef,
            model: formModel.value,
            rules: rules.value,
            onSubmit: _withModifiers(submitForm, ["prevent"])
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NFormItem), { path: "username" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NInputGroup), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(NInputGroupLabel), { size: "large" }, {
                        default: _withCtx(() => [
                          _hoisted_1
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(NInput), {
                        value: formModel.value.username,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((formModel.value.username) = $event)),
                        size: "large",
                        placeholder: "Uživatelské jméno",
                        disabled: pending.value
                      }, null, 8, ["value", "disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(NSpace), {
                justify: "center",
                class: "py-m"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NButton), {
                    type: "primary",
                    size: "large",
                    "attr-type": "submit",
                    style: { width: '100%' },
                    disabled: pending.value || formModel.value.username === null || formModel.value.username === '',
                    loading: pending.value
                  }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  }, 8, ["disabled", "loading"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules", "onSubmit"])),
      _createVNode(_unref(NSpace), {
        justify: "center",
        class: "pt-m"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_router_link, {
            to: "/",
            class: "text--s"
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})